import api, { addAuthToData, addAuthToParams } from './api';

export const productsService = {
  // Create product
  createProduct: async (productData) => {
    try {
      const dataWithAuth = addAuthToData(productData);
      const response = await api.post('/products.php?action=create', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get all products
  getProducts: async () => {
    try {
      const response = await api.get('/products.php?action=read');
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get single product
  getProduct: async (id) => {
    try {
      const response = await api.get(`/products.php?action=read&id=${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Update product
  updateProduct: async (productData) => {
    try {
      const dataWithAuth = addAuthToData(productData);
      const response = await api.post('/products.php?action=update', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Delete product
  deleteProduct: async (id) => {
    try {
      const url = addAuthToParams(`/products.php?action=delete&id=${id}`);
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  }
};